import React from 'react';
import useI18n from 'hooks/I18n/useI18n';
import Text from 'components/ProductIdentity/Text.jsx';

const MaintenancePage = () => {
    const { trans } = useI18n();

    return (
        <>
            <div className="maintenance-illustration" />
            <div className="maintenance-container">
                <div className="maintenance-message">
                    <Text
                        className="maintenance-message-title"
                        size="20px"
                        lineHeight="28px"
                        weight="700"
                        family="mr"
                        color="grey8"
                    >
                        {trans('maintenancePage.title')}
                    </Text>
                    <Text
                        className="maintenance-message-description"
                        size="16px"
                        lineHeight="24px"
                        weight="400"
                        family="inter"
                        color="gray5"
                    >
                        {trans('maintenancePage.description1')}
                    </Text>
                </div>
            </div>
        </>
    );
};

export default MaintenancePage;
